<template>
  <div>
    <h2 class="text-lg font-bold mb-4">Регистрация</h2>
    <form @submit.prevent="register">
      <input v-model="username" placeholder="Логин" class="border p-2 w-full mb-2" />
      <input v-model="password" type="password" placeholder="Пароль" class="border p-2 w-full mb-4" />
      <button class="bg-green-500 text-white px-4 py-2 rounded">Создать аккаунт</button>
    </form>
    <p class="mt-3 text-sm">
      Уже есть аккаунт? <router-link to="/login">Войти</router-link>
    </p>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue';
import { useRouter } from 'vue-router';

defineOptions({
  name: 'RegisterView'
});

const router = useRouter();
const username = ref('');
const password = ref('');

const register = async () => {
  const res = await fetch(`${import.meta.env.VITE_API_URL}/register`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ username: username.value, password: password.value }),
  });

  if (res.ok) {
    alert('Аккаунт создан!');
    router.push('/login');
  } else {
    alert('Ошибка: имя занято');
  }
};
</script>
